export class MediaUploadError extends Error {
  constructor(
    public readonly status: number,
    public readonly bodyText: string,
    public readonly responseJson?: unknown
  ) {
    super(`Media upload failed: HTTP ${status}`);
    this.name = 'MediaUploadError';
  }
}
